import React from 'react';
import styled from 'styled-components';
import VirtualEventRenderer from 'common/compounds/VirtualEventRenderer';
import { ModalManager } from 'common/components/TouchpointEditor/contexts/ModalManager';
import { SuiSpinner } from '@splashthat/sui';
import { useColors } from 'common/entities/color';
import { useFonts } from 'common/entities/font';
import { useLogos } from 'common/entities/logo';
import { PAGE_STATE_DURING_EVENT, PAGE_STATE_DURING_EVENT_MULTI_SESSION } from 'common/constants/virtualEvent';

import GatekeeperHeartbeatManager from '../contexts/GatekeeperHeartbeatManager';
import { useFlags } from '../../../utils/react-context';
import { useVirtualEventAttendeeData } from '../contexts/VirtualEventAttendeeDataManager';

const SuiSpinnerWrapper = styled(SuiSpinner)`
    position: absolute;
    left: 50%;
    top: 50%;
`;

export default function VirtualEventApp() {
    const { isGatekeeperFeatureFlagEnabled } = useFlags();
    const colors = useColors();
    const fonts = useFonts();
    const logos = useLogos();
    const virtualEventData = useVirtualEventAttendeeData();

    const onCheckInButtonClick = () => virtualEventData.actions.checkIn();

    const { settings: { embedConfig, hasAltEmbed, altEmbedConfig, engine = {} } = {}, guest, event } = virtualEventData;

    const isGatekeeperEnabled =
        [PAGE_STATE_DURING_EVENT, PAGE_STATE_DURING_EVENT_MULTI_SESSION].includes(virtualEventData.currentPageState) &&
        isGatekeeperFeatureFlagEnabled;

    if (virtualEventData.isLoading) {
        return <SuiSpinnerWrapper />;
    }

    return (
        <GatekeeperHeartbeatManager
            errorMessage="This link is open in another window or device. Close out of any other windows and refresh this page to join the event."
            enabled={isGatekeeperEnabled}
            guestAccessHash={virtualEventData?.tokens?.guestAccessHash}
            guestId={guest.id}
            eventId={event.id}
            onGateClosed={() => {
                virtualEventData.actions.setTokens({
                    ...virtualEventData.tokens,
                    checkInToken: null,
                });
            }}
        >
            <ModalManager>
                <VirtualEventRenderer
                    currentPageState={virtualEventData.currentPageState}
                    embedConfig={embedConfig || {}}
                    hasAltEmbed={hasAltEmbed}
                    altEmbedConfig={altEmbedConfig || {}}
                    event={event}
                    colors={colors}
                    fonts={fonts}
                    logos={logos}
                    guest={guest}
                    engine={engine}
                    onCheckInClick={onCheckInButtonClick}
                />
            </ModalManager>
        </GatekeeperHeartbeatManager>
    );
}
